import React from 'react';
import t from 'react-translate';
import NvSwitch from 'shared/components/inputs/nv-switch';
import { config as appConfig } from '@config/config.json';
import { config } from '@config/pendo.config.json';
import cardTextStyles from './ai-hub-styles';

export const GEN_AI_ARTICLE_LINK = `${appConfig.helpLink}/article/ART-1816`;

interface AILearningAssistantToggleProps {
  onChange: (value: boolean) => void;
  value: boolean;
}

const AILearningAssistantToggle: React.FC<AILearningAssistantToggleProps> = ({ onChange, value }) => {
  const label = t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.AI_LEARNING_ASSISTANT_TOGGLE();

  return (
    <div
      css={cardTextStyles}
      className='d-flex align-items-center justify-content-between'
    >
      <div className='mr-4'>
        <div className='card-text font-weight-bold mb-1'>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.AI_LEARNING_ASSISTANT_TITLE()}
        </div>
        <div className='card-text'>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.ENABLE_AI_LEARNING_ASSISTANT(
            GEN_AI_ARTICLE_LINK,
          )}
        </div>
        <p className='mb-0'>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.PLEASE_NOTE()}
        </p>
      </div>
      <NvSwitch
        checked={value}
        onChange={onChange}
        ariaLabel={label}
        className='flex-shrink-0'
        dataQa={value ? config.pendo.settings.enabledAiLearning : config.pendo.settings.disabledAiLearning}
      />
    </div>
  );
};

export default AILearningAssistantToggle;
